import React from 'react'
import { List, Steps } from 'antd';
import { type IUnitKey, type Unit } from '../../../../store/slices/unitsSlice'
import { type IViewing } from '../../../../store/slices/viewingsSlice'
import StepComponent from '../offerTimelines/StepComponent';
import { timeStringInScheduler } from '../../../../functions/agent/date/timeStringInScheduler';
import { getBelongsUnitForViewing } from '../../../../functions/shared/schedule/getBelongsUnit';
interface IProps {
    viewing: IViewing
    unit: Unit
    unitKey: IUnitKey
    userType: string
    isMyUnit: boolean
}


export default function GroupTimelineViewing({ viewing, unit, unitKey, userType, isMyUnit }: IProps): JSX.Element {
    let process = 0
    let DropOutDate = ''; let PickUpDate = ''
    if (unitKey !== null) {
        DropOutDate = unitKey?.attributes?.DropOutDate
        PickUpDate = unitKey?.attributes?.PickUpDate
        if (process > 0) {
            process++
        }
    }

    const unitStatuses = unit.attributes.Statuses
    const viewingStatuses = viewing?.attributes?.Statuses as string[]
    const unitKeyStatus = unitKey?.attributes?.Status

    let titleApproving = ''
    let descriptionApproving = ''

    let titleProcessing = ''
    let descriptionTitleProcessing = ''




    if (unitStatuses?.includes('Digital lock')) {
        titleProcessing = 'Wait for viewing approval and setting Digital Lock Password'
        descriptionTitleProcessing = 'Shortly after confirmation, we will send you a Digital Lock Password that you can use to enter the apartment.'

        titleApproving = 'Viewing time was approved'
        descriptionApproving = ' Please use the password that shared with you to get access to the unit apartment'

    } if (unitStatuses?.includes('Door open')) {
        titleProcessing = 'Viewing approved.'
    } if (unitStatuses?.includes('Keys in BSO office')) {
        titleProcessing = 'Please wait, soon we will indicate the date and time of receipt of keys.'
        descriptionTitleProcessing = 'We confirmed the viewing, but the process of interaction with the keys has not been registered by the admin, please wait, soon he will indicate the date and time of receipt of keys.'

        titleApproving = 'Viewing time was approved.'
        descriptionApproving = unitKey !== null ? `You should pick up the keys on ${timeStringInScheduler(PickUpDate).split(',')[0]} - ${timeStringInScheduler(PickUpDate).split(',')[1]}` : 'Please visit the BSO Office in the set time below to pick up the unit keys.'


    } if (unitStatuses?.includes('Occupied')) {
        titleProcessing = 'Please wait for viewing approval'
        descriptionTitleProcessing = 'Our specialist will approve your viewing soon.'

        titleApproving = 'Viewing time was approved.'
        descriptionApproving = 'Feel free to make your viewing!'

    } if (unitStatuses?.includes('Building Management')) {
        titleProcessing = viewingStatuses?.includes('Rescheduled by BSO') ? 'Please set another convenient viewing time for you' : 'Wait for viewing approval'
        descriptionTitleProcessing = viewingStatuses?.includes('Rescheduled by BSO') ? "The request will be fulfilled again." : 'Our specialist will approve your viewing soon.'
        titleApproving = 'Viewing time was approved.'

    } if (unitStatuses?.includes('Door close') || unitStatuses?.includes('Agent Unit')) {
        titleProcessing = isMyUnit ? 'Approve viewing on your unit' : 'Wait for viewing approval'
        descriptionTitleProcessing = isMyUnit ? '' : 'Agent will approve your viewing soon'
        titleApproving = isMyUnit ? 'Your unit\'s viewing has been approved by you' : 'Your viewing time has been approved'

    } if (unitStatuses?.includes('Landlord Unit')) {
        titleProcessing = isMyUnit ? 'Approve viewing on your unit' : 'Wait for viewing approval'
        descriptionTitleProcessing = isMyUnit ? '' : 'Landlord will approve your viewing soon'
        titleApproving = isMyUnit ? 'Your unit\'s viewing has been approved by you' : 'Your viewing time has been approved'

    } if (unitStatuses?.includes('Special Request')) {
        titleProcessing = viewingStatuses?.includes('Rescheduled by BSO') ? 'Please set another convenient viewing time for you' : 'Wait for viewing approval'
        descriptionTitleProcessing = viewingStatuses?.includes('Rescheduled by BSO') ? "The request will be fulfilled again." : 'Our specialist will approve your viewing soon.'
        titleApproving = 'Viewing time was approved.'
    }








    const stepFeedbackAndReview = 'Add feedback about the finished viewing'
    const descriptionFeedbackAndReview = 'Please add feedback about the results of this viewing by selecting options on the quiz page and try to submit an offer if your client is ready for it.'

    let titleClosure = 'Viewing completed successfully'
    let descriptionClosure = 'Congratulations on another completed viewing! Let’s make a new one with the BSO Club!'


    if (viewingStatuses?.includes('Rescheduled by BSO')) {
        process = 0
        titleProcessing = 'Please check time, and approve the new time of viewing'
        descriptionTitleProcessing = unitKey !== null ? `You should pick up the keys on ${timeStringInScheduler(PickUpDate).split(',')[0]} - ${timeStringInScheduler(PickUpDate).split(',')[1]}` : 'Please visit the BSO Office in the set time below to pick up the unit keys.'
    }
    if (viewingStatuses?.includes('In-process') || viewingStatuses?.includes('Rescheduled by agent') || viewingStatuses?.includes('Rescheduled by landlord')) {
        process = 0
    }


    const task = getBelongsUnitForViewing(viewing)
    const groupProcessing = [
        {
            title: <StepComponent
                title={titleProcessing}
                description={descriptionTitleProcessing}
                process={0}
                currentProcess={process}
                statuses={viewingStatuses}
                rejectReason={process === 0 ? viewing?.attributes?.RejectReason ?? undefined : undefined}
                task={task}
            />
        }
    ]


    if (viewingStatuses?.includes('Approved')) {
        process = 0
        if (unitStatuses?.includes('Keys in BSO office')) {
            if (unitKeyStatus?.includes('Waiting for agent')) {
                titleApproving = 'Time to pick up the unit keys at the BSO office'
                descriptionApproving = unitKey !== null ? `You should pick up the keys on ${timeStringInScheduler(PickUpDate).split(',')[0]} - ${timeStringInScheduler(PickUpDate).split(',')[1]}` : 'Please visit the BSO Office by the time indicated below to pick up the unit keys.'
            } else if (unitKeyStatus?.includes('In-process')) {
                titleApproving = 'You get the keys. Make your viewing'
                descriptionApproving = 'Please return the unit keys after finishing the viewing.'
            } else if (unitKeyStatus?.includes('Completed')) {
                process = 1
            } else {
                titleApproving = 'Time to return unit keys to BSO Office'
                descriptionApproving = unitKey !== null ? `You should return the keys by ${timeStringInScheduler(DropOutDate).split(',')[0]} - ${timeStringInScheduler(DropOutDate).split(',')[1]}` : 'Please visit the BSO Office in the set time below to drop out the unit keys.'
            }
        }
    } else if (viewingStatuses?.includes('Waiting for feedback')) {
        if (unitStatuses?.includes('Keys in BSO office')) {
            if (unitKeyStatus?.includes('Waiting for agent')) {
                titleApproving = 'Time to pick up the unit keys at the BSO office'
                descriptionApproving = unitKey !== null ? `You should pick up the keys on ${timeStringInScheduler(PickUpDate).split(',')[0]} - ${timeStringInScheduler(PickUpDate).split(',')[1]}` : 'Please visit the BSO Office by the time indicated below to pick up the unit keys.'
            } else if (unitKeyStatus?.includes('In-process')) {
                titleApproving = 'You get the keys. Make your viewing'
                descriptionApproving = 'Please return the unit keys after finishing the viewing.'
            } else if (unitKeyStatus?.includes('Completed')) {
                process = 1
            } else {
                titleApproving = 'Time to return unit keys to BSO Office'
                descriptionApproving = unitKey !== null ? `You should return the keys by ${timeStringInScheduler(DropOutDate).split(',')[0]} - ${timeStringInScheduler(DropOutDate).split(',')[1]}` : 'Please visit the BSO Office in the set time below to drop out the unit keys.'
            }
        } else {
            process = 1
        }
    }
    const groupViewingFeedback = [
        {
            title: <StepComponent
                title={titleApproving}
                description={descriptionApproving}
                process={0}
                unitKeyStatus={unitStatuses?.includes('Keys in BSO office') && unitKeyStatus ? unitKeyStatus : undefined}
                currentProcess={process}
                statuses={viewingStatuses}
            />
        },
        ...((unitStatuses?.includes('Keys in BSO office') && !unitKeyStatus?.includes('Completed')) || unitStatuses?.includes('Door close') ? [] : [
            {
                title: <StepComponent
                    title={stepFeedbackAndReview}
                    //   description={descriptionFeedbackAndReview}
                    process={1}
                    unitKeyStatus={unitStatuses?.includes('Keys in BSO office') && unitKeyStatus ? unitKeyStatus : undefined}
                    currentProcess={process}
                    statuses={viewingStatuses}
                    rejectReason={process === 0 ? viewing?.attributes?.RejectReason ?? undefined : undefined}
                />
            }
        ])
    ]


    if (viewingStatuses?.includes('Canceled')) {
        titleClosure = 'Viewing cancelled'
        descriptionClosure = 'Your viewing has been cancelled'
    } else if (viewingStatuses?.includes('Rejected')) {
        titleClosure = 'Your viewing was rejected by BSO'
        descriptionClosure = 'Unfortunately, our specialist has decided to reject your viewing because of the valuable reason stated above. Please reschedule the time of this viewing or create a new one'
    } else if (viewingStatuses?.includes('Waiting for complain')) {
        descriptionClosure = 'Your viewing is completed! But we have one more step to make free breath about it: our specialist will send you a review of your performance during this viewing.'
    }
    const groupClosure = [
        {
            title: <StepComponent
                title={titleClosure}
                process={0}
                currentProcess={process}
                statuses={viewingStatuses?.includes('Waiting for complain') ? ['Completed'] : viewingStatuses}
                rejectReason={process === 0 ? viewing?.attributes?.RejectReason ?? undefined : undefined}
                feedbackDescription={
                    viewingStatuses?.includes('Completed') && viewing?.attributes?.Feedback !== null
                        ? viewing?.attributes?.Feedback
                        : undefined
                }
                reviewDescription={
                    viewingStatuses?.includes('Completed') && viewing?.attributes?.Complaint !== null
                        ? viewing?.attributes?.Complaint
                        : undefined
                }
            />,
            status: 'finish',
        }
    ]


    const data = [
        ...(!(viewingStatuses[0].includes("Canceled") || viewingStatuses[0].includes("Rejected")) ?
            [{// Этап 1: ожидание одобрения push отклонено или отменено email + push // Этап 2:  одобрение и получение ключей  email + push
                title: 'Processing',
                status: undefined,
                icon: <i className="ki-duotone ki-loading fs-5x">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>,

                iconProcess: <i className="ki-duotone ki-loading fs-5x text-success">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>,
                description: 'Viewing request is awaiting approval. ',
                statuses: ['In-process', 'Rescheduled by agent', 'Rescheduled by other agent', 'Rescheduled by BSO', 'Rescheduled by landlord'],
                items: groupProcessing
            },
            {// просмотр и отзыв push
                title: 'Viewing & Feedback',
                status: undefined,
                icon: <i className="ki-duotone ki-time  fs-5x">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>,
                iconProcess: <i className="ki-duotone ki-time fs-5x text-success">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>,
                description: 'View the unit, provide feedback, review, the final steps before completion.',
                statuses: ['Approved', 'Waiting for feedback'],
                items: groupViewingFeedback
            }] : []),
        { // Этап 3: завершение email + push
            title: 'Closure',
            status: undefined,
            icon: <i className="ki-duotone ki-check fs-5x"></i>,
            iconProcess: <i className="ki-duotone ki-check fs-5x text-success"></i>,
            description: 'The stage where the viewing is closed as rejected, canceled  or completed.',
            statuses: ['Completed', 'Rejected', 'Canceled', 'Canceled by BSO', 'Canceled by agent', 'Canceled by other agent', 'Waiting for complain'],
            items: groupClosure
        },
    ];


    const activeStepIndex = data.findIndex(step => step.statuses.includes(viewingStatuses[0]));



    return (
        <div className='my-4 pt-2' style={{ maxWidth: '450px', width: '100%' }}>
            <List
                itemLayout="horizontal"
                dataSource={data}
                renderItem={(group, index) => {
                    const isActive = index === activeStepIndex;
                    const currentProcess = process;
                    return (
                        <div className='d-flex flex-column'>
                            <List.Item >
                                <div className='d-flex flex-column w-100'>
                                    <List.Item.Meta
                                        style={{
                                            lineHeight: 0.1
                                        }}
                                        avatar={
                                            <div className={`d-flex align-items-center justify-content-center w-100`}>
                                                {isActive ?
                                                    viewingStatuses[0].includes("Completed") ?
                                                        <span className={'border border-2 align-middle p-7 position-relative border-success  rounded rounded-circle'}>
                                                        </span> : viewingStatuses[0].includes("Canceled") || viewingStatuses[0].includes("Rejected") ?
                                                            <span className={'border border-2 align-middle p-7 position-relative border-danger  rounded rounded-circle'}>
                                                            </span> :
                                                            < span className={'spinner-border spinner-border-sm align-middle p-7 position-relative text-success'}>
                                                            </span>
                                                    : null}
                                                <span className={`position-${isActive ? 'absolute' : 'static'}`}>
                                                    {isActive ? viewingStatuses[0].includes("Canceled") || viewingStatuses[0].includes("Rejected") ? <i className="ki-duotone ki-cross-circle fs-5x text-danger">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i> : group.iconProcess : group.icon}
                                                </span>
                                            </div>
                                        }
                                        title={<div className='lh-1'><span className='lh-1 fs-4'>{group.title.toUpperCase()}</span></div>}
                                        description={<div className='lh-1'><span className='lh-1 fs-7'>{group.description}</span></div>}
                                    />
                                    <div className='ps-4 ms-4 mt-2'>
                                        {isActive &&
                                            <>
                                                <Steps
                                                    className='w-100'
                                                    style={{ marginTop: 8, width: '100%' }}
                                                    current={currentProcess}
                                                    status={undefined}
                                                    items={group.items}
                                                // items={group.items.map((item, idx) => ({
                                                //     ...item,
                                                //     status: idx < currentProcess ? "finish" : idx === currentProcess ? "process" : "wait"
                                                // }))}
                                                //  items={renderSteps(group.items, currentProcess)}
                                                />
                                                {group.items.length > 3 &&
                                                    <div className={'text-end mt-2'}>
                                                        <div className={'btn btn-light-secondary py-2 text-end text-dark  px-7'}>
                                                            {/* <div className="d-flex justify-content-around align-items-center w-30"
                                                                onClick={() => { setExpanded(!expanded); }}>
                                                                <Icon name={expanded ? 'play_circle' : 'expand_circle_up'} className={'fs-5'} />
                                                                <span className="ms-1 fs-8">{expanded ? 'Hide' : 'Show all'}</span>
                                                            </div> */}
                                                        </div>
                                                    </div>
                                                }
                                            </>
                                        }
                                    </div>
                                </div>
                            </List.Item>
                        </div >
                    )
                }}
            />
        </div >
    )
}
